import { ViewfinderCircleIcon } from '@heroicons/react/24/outline';
export const TargetIcon = ViewfinderCircleIcon;
